<!-- 角色权限 RolePermissions-->
<template>
  <div class="RolePermissions">
    <div class="form_header">
      <!-- <el-form ref="form" :model="userform" label-width="80px">
        <div class="form_list">
          <el-form-item label="角色：">
            <el-select v-model="userform.Product" placeholder="请选择角色">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <div class="btn_box">
            <el-button type="primary" @click="onSubmit">搜索</el-button>
            <el-button>取消</el-button>
          </div>
        </div>
      </el-form>-->
      <div>
        <!-- <el-button type="primary" icon="el-icon-upload2">导出</el-button> -->
        <el-button type="primary" icon="el-icon-plus" @click="addPoints">新增</el-button>
      </div>
    </div>
    <div class="user_list">
      <el-table :data="userList" style="width: 100%" :header-cell-style="rowStyle" :cell-style="rowStyle">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="title" label="角色名称"></el-table-column>
        <!-- <el-table-column prop="name" label="角色权限"></el-table-column> -->
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">复制</el-button> -->
            <el-button v-if="scope.row.role_id!==2" type="text" size="small" @click="editbox(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.role_id!==2" type="text" size="small" @click="removesize(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy_box">
      <el-pagination @current-change="handleCurrentChange" background prev-text="上一页" next-text="下一页" :current-page="currentindex" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totals"></el-pagination>
    </div>
    <!-- 新增--编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="pop_up" @close="cancelform">
      <el-form :model="Edform" :rules="rules" label-width="100px">
        <el-form-item label="角色名称">
          <el-input v-model="Edform.title"></el-input>
        </el-form-item>
        <el-form-item label="角色权限">
          <!-- <el-checkbox-group v-model="Edform.rule_ids">
            <el-checkbox label="权限 A"></el-checkbox>
            <el-checkbox label="权限 B"></el-checkbox>
            <el-checkbox label="权限 C"></el-checkbox>
          </el-checkbox-group>-->
          <div class="xuan_box">
            <el-tree ref="tree" :props="props" :data="rolerlist" node-key="id" show-checkbox :default-checked-keys="Edform.rule_ids" @check-change="handleCheckChange"></el-tree>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelform">取 消</el-button>
        <el-button type="primary" @click="SubmitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  rolelists,
  roleadd,
  rolerules,
  roledelete,
  roleedit
} from "../../api/system.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      userform: {
        Product: "",
        name: ""
      },
      Edform: {
        title: "",
        rule_ids: []
      },
      userList: [
        {
          name: "9f30002",
          num: "1000",
          name1: "启用"
        }
      ],
      currentindex: 1,
      pageSize: 10,
      totals: 100,
      titleName: "新增",
      pop_up: false,
      rules: {
        reason: [{ required: true, message: "请输入拒绝原因", trigger: "blur" }]
      },
      rolerlist: [],
      props: {
        label: "lable",
        children: "children"
      }
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    rowStyle() {
      return { textAlign: "center" };
    },
    //角色列表 rolelists
    roledata() {
      let data = {
        page: this.currentindex,
        page_size: this.pageSize
      };
      rolelists(data).then(res => {
        // console.log("角色列表", res);
        if (res.status_code == 200) {
          this.userList = res.data.data;
          this.totals = res.data.total;
        }
      });
    },
    //页面菜单列表
    yedata() {
      rolerules().then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.rolerlist = res.data;
        }
      });
    },
    //分页切换
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentindex = val;
      this.roledata();
    },
    //搜索
    onSubmit() {
      // console.log(this.userform);
    },

    //复制
    handleClick(e) {
      // console.log(e);
    },
    // 新增--弹窗
    addPoints() {
      this.titleName = "新增";
      this.yedata();
      this.pop_up = true;
    },
    //编辑弹窗
    editbox(e) {
      // console.log(e);
      this.titleName = "编辑";
      this.yedata();
      this.Edform.title = e.title;
      this.Edform.role_id = e.role_id;
      if (e.rule_ids != "") {
        this.Edform.rule_ids = e.rule_ids.split(",");
      } else {
        this.Edform.rule_ids = [];
      }
      this.pop_up = true;
    },
    //选中
    handleCheckChange(data, checked, indeterminate) {
      // console.log(data, checked, indeterminate);
      // console.log(this.Edform.rule_ids);
      this.Edform.rule_ids = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
      // console.log(this.Edform.rule_ids, "选中的节点");
    },
    //弹窗提交
    SubmitAdd() {
      // console.log(this.Edform);
      if (this.titleName == "新增") {
        // roleadd
        let data = {
          title: this.Edform.title,
          rule_ids: this.Edform.rule_ids.toString()
        };
        roleadd(data).then(res => {
          // console.log(res);
          if (res.status_code == 200) {
            this.cancelform();
            this.currentindex = 1;
            this.roledata();
            this.$message({
              type: "success",
              message: "添加成功!"
            });
          }
        });
      }
      if (this.titleName == "编辑") {
        let data = {
          role_id: this.Edform.role_id,
          title: this.Edform.title,
          rule_ids: this.Edform.rule_ids.toString()
        };
        roleedit(data).then(res => {
          // console.log(res);
          if (res.status_code == 200) {
            this.cancelform();
            this.currentindex = 1;
            this.roledata();
            this.$message({
              type: "success",
              message: "添加成功!"
            });
          }
        });
      }
    },
    //关闭弹窗
    cancelform() {
      this.Edform.title = "";
      this.Edform.rule_ids = null;
      this.pop_up = false;
    },
    //删除
    removesize(e) {
      // console.log(e);
      let data = {
        role_id: e.role_id
      };
      roledelete(data).then(res => {
        if (res.status_code == 200) {
          this.currentindex = 1;
          this.roledata();
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        }
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.roledata();
    this.yedata();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.RolePermissions {
  padding: 20px 30px 0;
  .form_header {
    display: flex;
    justify-content: space-between;
    .btn_box {
      margin-left: 20px;
    }
  }
  .form_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .user_list {
    padding: 20px 0;
  }
}
</style>
<style lang='scss'>
.RolePermissions {
  .form_header {
    .el-form-item {
      margin-bottom: 0;
    }
  }
  // .xuan_box{
  //   height: 100%;
  //   .el-tree{
  //     display: flex;
  //     justify-content: space-between;
  //   }
  // }
  .el-table {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
  }
}
</style>